import { ASNAPI } from './ASN'
import { AppointmentAPI } from './Appointments'
import { Attachments } from './Attachments'
import { AuditAPI } from './Audits'
import { BarcodedUnits } from './BarcodedUnits'
import { BatchesAPI } from './Batches'
import { BatchSkusAPI } from './BatchSkus'
import { Carriers } from './Carriers'
import { CartAPI } from './Carts'
import { Cases } from './Cases'
import { Clients } from './Clients'
import { Containers } from './Containers'
import { DamagedAPI } from './Damaged'
import { DockAPI } from './Docks'
import { DriverAPI } from './Drivers'
import { Events } from './Events'
import { Facilities } from './Facilities'
import { Flags } from './Flags'
import { Freight } from './Freight'
import { FoundAPI } from './Found'
import { IntegrationAPI } from './integrations'
import { Lookup } from './Lookup'
import { LostAPI } from './Lost'
import { Markets } from './Markets'
import { MoveAPI } from './Move'
import { Pallets } from './Pallets'
import { Parcel } from './Parcel'
import { PermissionsAPI } from './Permissions'
import { Picking } from './Picking'
import { Places } from './Places'
import { Products } from './Products'
import { Skus } from './Skus'
import { SupplyChainAPI } from './SupplyChains'
import { Units } from './Units'
import { API } from './types'

export class SC {
  api: API

  constructor(api: API) {
    this.api = api
  }

  get asn() {
    const api = new ASNAPI(this.api)
    Object.defineProperty(this, 'asn', { value: api })
    return api
  }

  get appointments() {
    const api = new AppointmentAPI(this.api)
    Object.defineProperty(this, 'appointments', { value: api })
    return api
  }

  get attachments() {
    const api = new Attachments(this.api)
    Object.defineProperty(this, 'attachments', { value: api })
    return api
  }

  get audits() {
    const api = new AuditAPI(this.api)
    Object.defineProperty(this, 'audits', { value: api })
    return api
  }

  get barcodedUnits() {
    const api = new BarcodedUnits(this.api)
    Object.defineProperty(this, 'barcodedUnits', { value: api })
    return api
  }

  get carriers() {
    const api = new Carriers(this.api)
    Object.defineProperty(this, 'carriers', { value: api })
    return api
  }

  get carts() {
    const api = new CartAPI(this.api)
    Object.defineProperty(this, 'carts', { value: api })
    return api
  }

  get batches() {
    const api = new BatchesAPI(this.api)
    Object.defineProperty(this, 'batches', { value: api })
    return api
  }

  get batchSkus() {
    const api = new BatchSkusAPI(this.api)
    Object.defineProperty(this, 'batchSkus', { value: api })
    return api
  }

  get cases() {
    const api = new Cases(this.api)
    Object.defineProperty(this, 'cases', { value: api })
    return api
  }

  get clients() {
    const api = new Clients(this.api)
    Object.defineProperty(this, 'clients', { value: api })
    return api
  }

  get containers() {
    const api = new Containers(this.api)
    Object.defineProperty(this, 'containers', { value: api })
    return api
  }

  get damaged() {
    const api = new DamagedAPI(this.api)
    Object.defineProperty(this, 'damaged', { value: api })
    return api
  }

  get docks() {
    const api = new DockAPI(this.api)
    Object.defineProperty(this, 'docks', { value: api })
    return api
  }

  get drivers() {
    const api = new DriverAPI(this.api)
    Object.defineProperty(this, 'drivers', { value: api })
    return api
  }

  get events() {
    const api = new Events(this.api)
    Object.defineProperty(this, 'events', { value: api })
    return api
  }

  get facilities() {
    const api = new Facilities(this.api)
    Object.defineProperty(this, 'facilities', { value: api })
    return api
  }

  get flags() {
    const api = new Flags(this.api)
    Object.defineProperty(this, 'flags', { value: api })
    return api
  }

  get integrations() {
    const api = new IntegrationAPI(this.api)
    Object.defineProperty(this, 'integrations', { value: api })
    return api
  }

  get markets() {
    const api = new Markets(this.api)
    Object.defineProperty(this, 'markets', { value: api })
    return api
  }

  get move() {
    const api = new MoveAPI(this.api)
    Object.defineProperty(this, 'move', { value: api })
    return api
  }

  get pallets() {
    const api = new Pallets(this.api)
    Object.defineProperty(this, 'pallets', { value: api })
    return api
  }

  get permissions() {
    const api = new PermissionsAPI(this.api)
    Object.defineProperty(this, 'permissions', { value: api })
    return api
  }

  get picking() {
    const api = new Picking(this.api)
    Object.defineProperty(this, 'picking', { value: api })
    return api
  }

  get places() {
    const api = new Places(this.api)
    Object.defineProperty(this, 'places', { value: api })
    return api
  }

  get products() {
    const api = new Products(this.api)
    Object.defineProperty(this, 'products', { value: api })
    return api
  }

  get skus() {
    const api = new Skus(this.api)
    Object.defineProperty(this, 'skus', { value: api })
    return api
  }

  get units() {
    const api = new Units(this.api)
    Object.defineProperty(this, 'units', { value: api })
    return api
  }

  get lookup() {
    const api = new Lookup(this.api)
    Object.defineProperty(this, 'lookup', { value: api })
    return api
  }

  get lost() {
    const api = new LostAPI(this.api)
    Object.defineProperty(this, 'lost', { value: api })
    return api
  }

  get found() {
    const api = new FoundAPI(this.api)
    Object.defineProperty(this, 'found', { value: api })
    return api
  }

  get freight() {
    const api = new Freight(this.api)
    Object.defineProperty(this, 'freight', { value: api })
    return api
  }

  get parcel() {
    const api = new Parcel(this.api)
    Object.defineProperty(this, 'parcel', { value: api })
    return api
  }

  get supply_chains() {
    const api = new SupplyChainAPI(this.api)
    Object.defineProperty(this, 'supply_chains', { value: api })
    return api
  }
}
